import { Stack, Text } from "@mantine/core"

import {
  CommunicationStudioClasses,
  CUSTOMISATION_CATEGORIES,
} from "@tfg/types/constants/communication-studio.constant"
import { AGECResponses } from "@tfg/types/endpoints/agec"
import { EcoScoreDisplayModeSchema } from "@tfg/types/schemas/communication-studio/components"
import {
  ecoscoreAlignCSSVariable,
  textColorCssVariable,
} from "@tfg/types/schemas/communication-studio/cssVariables"
import {
  DEFAULT_ECOSCORE_DISPLAY_MODE,
  EcoScoreDisplayMode,
} from "@tfg/types/types/communication-studio/configurations.types"

import { useGetStylingParametersContext } from "../context/stylingParameters/useGetStylingParametersContext"
import { useGetTranslationsContext } from "../context/translationsContext/useGetTranslationsContext"
import { DesignStudioParametersToolkit } from "../utils/designStudioParametersToolkit"

import { EcoScoreSVG } from "./EcoLabel/EcoScoreSVG"

type EcoScoreProps = {
  agecData: AGECResponses.GenericAgecData
  ecoScoreDataSource: string | null
  ecoScoreDisplayMode: EcoScoreDisplayMode | null
}

export const DEFAULT_ECOSCORE_SOURCE = "ecobalyse"

export const EcoScore = ({
  agecData,
  ecoScoreDataSource = DEFAULT_ECOSCORE_SOURCE,
  ecoScoreDisplayMode,
}: EcoScoreProps) => {
  const { t } = useGetTranslationsContext()
  const { stylingParameters } = useGetStylingParametersContext()

  if (!agecData.ecoScoreData) {
    return null
  }

  const ecoScoreData =
    agecData.ecoScoreData.sources[
      ecoScoreDataSource ?? DEFAULT_ECOSCORE_SOURCE
    ] ?? null
  if (!ecoScoreData || ecoScoreData.ecoScoreCost === null) {
    return null
  }

  const { ecoScoreCost, ecoScoreCostPer100g } = ecoScoreData
  return (
    <Stack
      align={DesignStudioParametersToolkit.getCssVariableLiteralName(
        ecoscoreAlignCSSVariable
      )}
      justify="center"
      w="100%"
    >
      {(ecoScoreDisplayMode ?? DEFAULT_ECOSCORE_DISPLAY_MODE) ===
      EcoScoreDisplayModeSchema.enum.b2c ? (
        <EcoScoreSVG cost={ecoScoreCost} costPer100g={ecoScoreCostPer100g} />
      ) : (
        <Text
          w="100%"
          className={CommunicationStudioClasses.ECOSCORE_B2B}
          c={DesignStudioParametersToolkit.getCssVariableLiteralName(
            textColorCssVariable
          )}
          style={DesignStudioParametersToolkit.spreadStylingParameters({
            category: CUSTOMISATION_CATEGORIES.GLOBAL,
            stylingParameters,
            stylingParamKeys: ["letterSpacing"],
          })}
        >
          {t("ecoScore.b2b", { cost: ecoScoreCost.toString() })}
        </Text>
      )}
    </Stack>
  )
}
